// 这个文件是用来添加临时多语言的

exports.addEn = {
    label: {
        title: '你好'
    },
    tableHeader: {
        
    },
    button: {
        
    },
    tip: {
        
    },
    tabName: {
        
    },
}